import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiConstants } from '../../common/constants/api-url.constant';
import { ContentType } from '../../common/enum/content-type.enum';
import { Content } from '../../common/models/content.type';

@Injectable({
  providedIn: 'root',
})
export class PrivacyPolicyService {
  private http = inject(HttpClient);
  private apiConstants = inject(ApiConstants);

  /**
   * Get Privacy Policy or Terms by type
   * @param type ContentType enum
   * @returns Observable<Content>
   */
  getPrivacyPolicy(type: ContentType): Observable<Content> {
    return this.http.get<Content>(this.apiConstants.GET_POLICY(type)).pipe(
      map((response: Content) => {
        // Optional: transform response if needed
        return response;
      }),
      catchError((error) => {
        console.error('Error fetching privacy policy:', error);
        return throwError(() => new Error('Failed to fetch privacy policy.'));
      })
    );
  }
}
